<template>
  <div
    :key="_.get(step2, 'dealer', '')"
    class="consultation-step3"
  >
    <div class="consultation-step3__form consultation__wrapper">
      <div class="consultation__col">
        <div class="consultation__wrapper">
          <div class="consultation__col">
            <BaseInput
              v-model="formData.firstName"
              :label="fields.firstName.label"
              :required="fields.firstName.required"
              :errorMsg="errorMessages.firstName"
              class="consultation-step3__form-input"
            />
          </div>
          <div class="consultation__col">
            <BaseInput
              v-model="formData.lastName"
              :label="fields.lastName.label"
              :required="fields.lastName.required"
              :errorMsg="errorMessages.lastName"
              class="consultation-step3__form-input"
            />
          </div>
        </div>
        <div class="consultation__wrapper">
          <div class="consultation__col consultation__col_w100">
            <BaseInput
              v-model="formData.phone"
              :label="fields.phone.label"
              :required="fields.phone.required"
              :errorMsg="errorMessages.phone"
              type="tel"
              class="consultation-step3__form-input"
            />
          </div>
        </div>
        <div class="consultation__wrapper">
          <div class="consultation__col consultation__col_w100">
            <BaseInput
              v-model="formData.email"
              :label="fields.email.label"
              :required="fields.email.required"
              :errorMsg="errorMessages.email"
              class="consultation-step3__form-input"
            />
          </div>
          <div
            v-if="_.get(fields, 'contactMethod', '')"
            class="consultation__col consultation__col_w100"
          >
            <BaseSelect
              v-model="formData.contactMethod"
              :items="_.get(fields, 'contactMethod.items', [])"
              :label="_.get(fields, 'contactMethod.label', '')"
              :placeholder="_.get(fields, 'contactMethod.label', '')"
              :required="_.get(fields, 'contactMethod.required', false)"
              :errorMsg="errorMessages.contactMethod"
              :emitOnCreate="false"
              itemTextKey="label"
              itemValueKey="value"
              class="consultation-step3__form-input"
              @input="contactMethodSelected"
            />
          </div>
          <div class="consultation__col consultation__col_w100">
            <BaseInput
              v-show="isSocialLink"
              v-model="formData.socialLink"
              :label="_.get(fields, 'socialLink.label', '')"
              :required="_.get(fields, 'socialLink.required', false)"
              :errorMsg="errorMessages.socialLink"
              type="email"
              class="consultation-step3__form-input"
            />
          </div>
        </div>

        <h3 class="consultation-step3__form-time-title">
          {{ timeTitle }}
        </h3>

        <div class="consultation__wrapper">
          <div class="consultation__col consultation__col_w50">
            <DatePicker
              :key="`key-${_.get(step2, 'dealer', '')}`"
              v-model="formData.date"
              :label="fields.date.label"
              :placeholder="fields.date.label"
              :required="fields.date.required"
              :isDataOnly="true"
              :errorMsg="errorMessages.date"
              class="consultation-step3__form-input"
              @timestampInput="getDateTimestamp"
            />
          </div>
          <div
            class="consultation__col consultation__col_w50"
          >
            <BaseSelect
              :key="`key-${_.get(step2, 'dealer', '')}`"
              :placeholder="timeLabel || fields.time.label"
              :items="timeList"
              :label="fields.time.label"
              :required="fields.time.required"
              :errorMsg="errorMessages.time"
              :disable="!formData.date"
              itemTextKey="label"
              class="consultation-step3__form-input"
              @input="getTimeTimestamp"
            />
          </div>

          <div class="consultation__col consultation__col_w100">
            <BaseInput
              v-model="formData.comment"
              :label="fields.comment.label"
              :required="fields.comment.required"
              :errorMsg="errorMessages.comment"
              :labelHtml="true"
              type="textarea"
              class="consultation-step3__form-input consultation-step3__form-input_area"
            />
          </div>
        </div>

        <!-- <div v-if="!!replaceText" class="consultation-step3__policy">
          <div class="consultation-step3__policy-data">
            <p class="consultation-step3__policy-text" v-html="replaceText" />
            <div
              v-show="isTextToggle"
              class="consultation-step3__policy-toggle"
              @click="textToggle"
            >
              &darr;
            </div>
          </div>
        </div> -->

        <div class="consultation__wrapper">
          <div class="consultation__col consultation__col_w100">
            <BaseCheckbox
              v-model="formData.agreement"
              class="consultation-step3__form-input"
              :errorMsg="errorMessages.agreement"
            >
              <span @click.prevent="setModal">
                {{ pageData.policyLabel }}
                <router-link
                  to="/policy"
                  class="stock__form-policy-link"
                >
                  {{ pageData.policyLink }}
                </router-link>
              </span>
            </BaseCheckbox>
          </div>
        </div>
        <div class="consultation__wrapper">
          <div class="consultation__col consultation__col_w100">
            <BaseCheckbox
              v-model="formData.marketing"
              class="consultation-step3__form-input"
              :errorMsg="errorMessages.marketing"
            >
              <span @click.prevent="setModal">
                {{ pageData.marketingLabel }}
                <router-link
                  to="/marketing"
                  class="stock__form-policy-link"
                >
                  {{ pageData.marketingLink }}
                </router-link>
              </span>
            </BaseCheckbox>
          </div>
        </div>
        <div class="consultation__wrapper">
          <div class="consultation__col consultation__col_w100">
            <BaseButton
              :disabled="!formData.agreement"
              class="consultation-step3__submit"
              @click="submitForm"
            >
              {{ submit.label }}
            </BaseButton>
          </div>
        </div>

        <p class="consultation-step3__hint" v-html="hint" />
      </div>
      <div class="consultation__col">
        <div class="consultation-step3__tabs-data">
          <div class="consultation-step3__tabs-data-item">
            <div class="consultation-step3__tabs-data-head">
              <p class="consultation-step3__tabs-data-label">
                {{ _.get(translate, 'selectModel', '') }}
              </p>
              <a
                href="#"
                class="consultation-step3__tabs-data-change"
                @click.prevent="goToStep(0)"
              >
                {{ _.get(translate, 'change', '') }}
              </a>
            </div>
            <div class="consultation-step3__tabs-data-body">
              <p class="consultation-step3__tabs-data-value">
                {{ `${step1.modelText}, ${step1.engineText}` }}
              </p>
            </div>

            <span class="icon icon-car" />
          </div>
          <div v-if="!$route.query.dealer" class="consultation-step3__tabs-data-item">
            <div class="consultation-step3__tabs-data-head">
              <p class="consultation-step3__tabs-data-label">
                {{ _.get(translate, 'selectDealer', '') }}
              </p>
              <a
                href="#"
                class="consultation-step3__tabs-data-change"
                @click.prevent="goToStep(1)"
              >
                {{ _.get(translate, 'change', '') }}
              </a>
            </div>
            <div class="consultation-step3__tabs-data-body">
              <p class="consultation-step3__tabs-data-value">
                {{ step2.dealersText }}
              </p>
            </div>

            <span class="icon icon-question-sign" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import DatePicker from '../DatePicker'
  import crud from '../crud'

  let interval

  export default {
    name: 'ConsultationStep3',

    components: {
      DatePicker
    },

    mixins: [crud],

    props: {
      fields: Object,
      timeTitle: String,
      text: String,
      submit: Object,
      hint: String,
      translate: Object
    },

    data () {
      return {
        formData: {},
        errorMessages: {},
        appealList: [
          {
            text: _.get(this.fields, 'appeal.items.1', ''),
            value: 1
          },
          {
            text: _.get(this.fields, 'appeal.items.2', ''),
            value: 2
          }
        ],
        timeList: [],
        dateTimestamp: '',
        timeLabel: '',
        isTextToggle: false,
        textHeight: 100,
        currentDayIndex: null,
        replaceText: '',
        isSocialLink: false,
        marketing: false
      }
    },

    computed: {
      ...mapState({
        pageData: (state) => state.main,
        step1: state => state.consultation.step1,
        step2: state => state.consultation.step2,
        showroomPeriodEnabled: state => state.consultation.showroomPeriodEnabled,
        showroomPeriodDisabled: state => state.consultation.showroomPeriodDisabled,
        serverTimestamp: state => state.globalData && state.globalData.currentTime,
        forPolicy: state => state.consultation.forPolicy
      })
    },

    watch: {
      'step2.dealer' () {
        this.timeLabel = ''
        this.timeList = []
        this.addDealerInfoToText()
        this.hidePolicyText()
      },

      serverTimestamp () {
        this.getCurrentDay()
        // this.getTimeTimestamp(_.get(this.timeList[0], 'label', ''), this.timeList[0])
      }
    },

    created () {
      interval = setInterval(async () => {
        await this.$store.dispatch('fetchGlobalData')
      }, 60000)
      this.addDealerInfoToText()

      Object.keys(this.fields).forEach((key) => {
        if (key === 'agreement') {
          this.$set(this.formData, key, false)
        } else {
          this.$set(this.formData, key, '')
        }
        this.$set(this.errorMessages, key, '')
      })
    },

    mounted () {
      this.hidePolicyText()
    },

    beforeDestroy () {
      clearInterval(interval)
    },

    methods: {
      setModal (e) {
        e.preventDefault()
        const stockMarketing = {
          marketingConsentText: this.pageData.marketingText,
          formSubmitUrl: this.pageData.marketingLink,
          closeButtonText: this.pageData.marketingCloseButtonText
        }

        const stockPolicy = {
          policyText: this.pageData.policyText,
          formSubmitUrl: this.pageData.policyLabel,
          closeButtonText: this.pageData.policyCloseButtonText
        }

        localStorage.setItem('stockPolicy', JSON.stringify(stockPolicy))
        localStorage.setItem('marketing', JSON.stringify(stockMarketing))
        this.$store.commit('setMarketing', stockMarketing)
        this.$store.commit('setStockPolicy', stockPolicy)
      },
      pushDataToDataLayer (params = {
        events: {
          name: 'formevent',
          componentName: 'book-dealer-appointment',
          componentGroup: 'forms',
          action: 'form-step',
          label: 'form-submit'
        },
        forms: {
          name: 'lead-book-dealer-appointment',
          step: 'form-submit',
          conversion: '1'
        }
      }, pushDataLayer = false, dataForDataLayer = { 'event': 'formevent' }) {
        const event = params.events || {}

        const page = {
          category: 'tools',
          subCategory: 'form',
          sectionlv1: 'forms',
          sectionlv2: 'book-dealer-appointment',
          language: _.get(this, '$store.state.currentLang', '')
        }

        const form = params.forms || {}

        const modelId = _.get(this, '$store.state.consultation.step1.modelId', '')
        const modelName = _.get(this, '$store.state.consultation.step1.modelText', '')

        const product = [{
          category: 'cars',
          subCategory: 'new-cars',
          productInfo: {
            productId: modelId,
            productName: modelName,
            tmeModelId: modelId,
            modelName
          }
        }]

        const dealer = {
          name: _.get(this, '$store.state.consultation.step2.dealersText', ''),
          dealerId: _.get(this, '$store.state.consultation.step2.dealerId', ''),
          city: _.get(this, '$store.state.consultation.step2.dealerCity', ''),
          zipcode: _.get(this, '$store.state.consultation.step2.dealerZipCode', '')
        }

        window.tngaDataLayer = { event, page, form, product, dealer }
        if (pushDataLayer) {
          window.dataLayer.push(dataForDataLayer)
        }
      },

      contactMethodSelected (value, obj) {
        this.isSocialLink = _.get(obj, 'social_link', '')
      },

      async hidePolicyText () {
        await this.$nextTick()
        const text = this.$el.querySelector('.consultation-step3__policy-data')
        if (!this._.isElement(text)) return false

        if (text.clientHeight >= this.textHeight) {
          text.style.height = this.textHeight + 'px'
          this.isTextToggle = true
        }
      },

      addDealerInfoToText () {
        this.replaceText = this.text

        Object.keys(this.forPolicy).forEach(key => {
          const re = new RegExp(`{${key}}`, 'gi')
          const str = this.replaceText
          this.replaceText = str.replace(re, this.forPolicy[key])
        })
      },

      getCurrentDay () {
        const date = new Date(this.dateTimestamp * 1000)
        this.currentDayIndex = date.getDay() - 1

        if (this.currentDayIndex === -1) {
          this.currentDayIndex = 6
        }

        this.setTimeList()
      },

      setTimeList () {
        const MINUTES_INTERVAL_TIME = 119
        // const MINUTES_BEFORE_CLOSING = 120
        const isCurrentDate = new Date(this.dateTimestamp * 1000).setHours(0, 0, 0, 0) === new Date(this.serverTimestamp * 1000).setHours(0, 0, 0, 0)
        const serverDateTimestamp = new Date(this.serverTimestamp * 1000).getTime()
        const timeList = this.showroomPeriodEnabled[this.currentDayIndex]

        // const gitItemTimeStamp = item => {
        //   const hours = Number(item.value.split(':')[0])
        //   const minutes = Number(item.value.split(':')[1])
        //   const lastItemTimestamp = new Date(this.dateTimestamp * 1000)
        //   lastItemTimestamp.setHours(hours, 0, 0, 0)
        //   lastItemTimestamp.setMinutes(minutes)
        //   return lastItemTimestamp.getTime()
        // }
        //
        // const lastItemTimestamp = gitItemTimeStamp(timeList[timeList.length - 1])

        console.log('timeList', timeList)
        this.timeList = timeList.filter(item => {
          const hours = Number(item.value.split(':')[0])
          const minutes = Number(item.value.split(':')[1])
          item.hours = hours
          item.minutes = minutes
          item.label = item.value

          if (isCurrentDate) {
            // if the current date is selected in the calendar
            let itemTimestamp = new Date(this.dateTimestamp * 1000)
            itemTimestamp.setHours(hours, 0, 0, 0)
            itemTimestamp.setMinutes(minutes)
            itemTimestamp = itemTimestamp.getTime()
            if (this.timeDifferenceMinute(itemTimestamp, serverDateTimestamp) >= MINUTES_INTERVAL_TIME) {
              // show time more than 2 hours
              return item
              // if (this.timeDifferenceMinute(lastItemTimestamp, itemTimestamp) > MINUTES_BEFORE_CLOSING) {}
            }
          } else {
            return item
          }
        })
      },

      goToStep (index) {
        this.$emit('goToStep', index)
      },

      async submitForm () {
        this.errorMessages = {}

        let params = {}
        if (this.$route.query.dealerId || this.$route.query.dealerName || this.$route.query.dealer) {
          params = {
            iframe: 1
          }
        }

        try {
          const { data } = await window.axios.post(this.submit.url, {
            ...this.step1,
            dealer: this.$route.query.dealer,
            ...this.step2,
            ...this.formData
          }, {
            params
          })

          this.pushDataToDataLayer(undefined, true)

          this.$emit('destroy')
          document.body.classList.remove('align-items-start')
          this.$store.commit('consultation/CLEAR_STEP1')
          this.$store.commit('consultation/CLEAR_STEP2')
          this.$store.commit('consultation/CLEAR_SHOWROOM_PERIOD')
          this.$store.commit('consultation/CLEAR_FOR_POLICY')
          this.$router.push({ name: 'thank-you', params: { url: '/online', ...data } })
        } catch (err) {
          Object.keys(this._.get(err, 'response.data', {})).forEach(key => {
            this.$set(this.errorMessages, key, this._.get(err, `response.data.${key}`, ''))
          })
          await this.$store.dispatch('fetchGlobalData')
          // console.error('Error post data:', err)
        }
      },

      getDateTimestamp (v) {
        this.dateTimestamp = v
        this.getCurrentDay()
        this.getTimeTimestamp(_.get(this.timeList[0], 'label', ''), this.timeList[0])
      },

      getTimeTimestamp (value, item) {
        const hours = _.get(item, 'hours', 0)
        const minutes = _.get(item, 'minutes', 0)
        const label = _.get(item, 'label', '')
        if (this.dateTimestamp) {
          const time = new Date(this.dateTimestamp * 1000)
          time.setHours(hours, 0, 0, 0)
          time.setMinutes(minutes)
          this.formData.time = time / 1000

          this.timeLabel = label
        }
      },

      textToggle (e) {
        if (!this._.isElement(e.currentTarget)) return
        const text = e.currentTarget.closest('.consultation-step3__policy-data')
        if (!text.classList.contains('active')) {
          text.classList.add('active')
          text.style.height = text.scrollHeight + 22 + 'px'
        } else {
          text.classList.remove('active')
          text.style.height = this.textHeight + 'px'
        }
      }
    }
  }
</script>
<style lang="scss">
  .consultation {
    .consultation-step3 {
      &__submit {
        @include mobile {
          width: 100%;
        }
      }

      &__info-text {
        //
      }

      &__form {
        &-input {
          min-width: 100%;

          .input__label {
            line-height: 24px;
          }

          .input__field {
            @include mobile() {
              font-size: 16px;
            }
          }

          .checkbox-inner {
            align-items: flex-start;
          }

          .checkbox__text {
            cursor: pointer;
          }
        }

        &-time-title {
          margin: 20px 0 16px;
          line-height: 28px;
          text-align: left;
        }
      }

      &__policy {
        margin: 0 0 40px;

        &-data {
          position: relative;
          overflow: hidden;
          transition: height 0.3s ease;

          &.active {
            .consultation-step3__policy-toggle {
              text-align: left;
              transform: rotate(-180deg);
            }
          }
        }

        &-text,
        p,
        a,
        em,
        i,
        u,
        li,
        ul,
        ol {
          margin-bottom: 20px;
          font-size: 9.33333px;
          line-height: 21px;
          color: #6a6b70;
          text-indent: 0;
        }

        ul,
        ol {
          padding-left: 22px;
        }

        &-toggle {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 100%;
          line-height: 22px;
          text-align: right;
          cursor: pointer;
          background: linear-gradient(90deg, hsla(0, 0%, 100%, 0.5), #fff 75%, #fff);
          background-size: 100% 100%;
        }
      }

      &__hint {
        margin: 20px 0 40px;
        font-size: 9.33333px;
        font-style: italic;
        color: #6a6b70;
      }

      &__tabs-data {
        padding: 30px;
        margin-bottom: 36px;
        background-color: $c-gray-extra-light-3;
        border-radius: 4px;

        &-item {
          position: relative;
          padding: 20px 0 0 35px;
          font-size: 13px;
          line-height: 24px;
          color: #6a6b70;

          &:not(:first-child) {
            margin-top: 20px;
            border-top: 1px solid $c-gray;
          }

          &:first-child {
            padding-top: 0;

            .icon {
              top: 0;
            }
          }
        }

        &-head {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
        }

        &-label {
          font-size: 13px;
          font-weight: bold;
          line-height: 20px;
          color: $c-gray-dark;
        }

        &-change {
          margin-left: 5px;
          font-size: 13px;
          color: $c-gray-dark;
          text-decoration: underline;

          @include hover {
            color: $c-gray-dark;
          }
        }

        &-body {
          //
        }

        &-value {
          font-size: 13px;
          line-height: 24px;
          color: #6a6b70;
        }

        .icon {
          position: absolute;
          top: 20px;
          left: 0;
          padding: 0;
          font-size: 20px;

          &::before {
            color: #7a7a7b;
          }
        }
      }
    }
  }
</style>
